import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-vaps-vehicle-two',
    templateUrl: './vaps-vehicle-two.component.html',
    styleUrls: ['./vaps-vehicle-two.component.scss'],
    standalone: false
})
export class VapsVehicleTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
